import { Box, Grid } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { routeName } from 'routes/routes-name'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import LabCompanyApi from 'api/setting/default-labs/lab-company.api'
import LabGroupsApi from 'api/setting/default-labs/lab-group.api'
import { getBranch, getClinicInfo, getSecureItem, setSecureItem } from 'utils/app.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputSecondNewRangePicker, { emptyRangePicker } from 'component/Input/InputSecondNewRangePicker'
import Loading from 'component/Loading'
import FucntionPrint from 'component/Print/print'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import RemunerationClinicFeeDentistList from './RemunerationClinicFeeDentistList'

/** STYLE */
import * as UseStyled from 'features/report/useStyled'

import AboutUs from 'api/admin/clinic-manage/about.api'
import { editBranchInfo } from 'app/slice/user.slice'
import { KEY_STORAGE } from 'constants/common'
import MainButton from 'new-components/buttons/main-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import { useDispatch } from 'react-redux'
import { UseSnCode } from 'utils/useSnCode'
import { ReportFormulaDF } from '../report-option-df'
import { ExportClinicFeeDentist } from './ExportDfToExcel'

type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
}

interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export default function RemunerationClinicFeeDentist() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<HTMLDivElement>(null)
  const momentNowRange = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const momentDate = () => momentNowRange
  const dispatch = useDispatch()

  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [loading, setLoading] = useState<boolean>(true)
  const [rangeDate, setRangeDate] = useState<string[]>(momentDate)
  const [receiptPrefix, setReceiptPrefix] = useState<any[]>([])
  const [prefix, setPrefix] = useState('ALL')

    const [selectedOptionPrice, setSelectedOptionPrice] = useState<any>(getSecureItem(KEY_STORAGE.REPORT_CONDITION) === 'TREATMENT' ? "TREATMENT" : 'PAID')
  
    
  const [doctorsMultiple, setDoctorsMultiple] = useState<DentistInterface[]>([])
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [selectDoctors, setSelectDoctors] = useState<any[]>(['ALL'])
  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const [labGroup, setLabGroup] = useState<any[]>([])
  const [labCompany, setLabCompany] = useState<any[]>([])
  const [labGroupId, setLabGroupId] = useState<number>(0)
  const [labCompanyId, setLabCompanyId] = useState<number>(0)

  const [optionDf, setOptionDf] = useState<'0' | '1' | '2' | '3'>('3')

  const [remunerationCfDentistData, getRemunerationCfDentistData] = useState<any[]>([])
  const [remunerationCfDentistPage, setRemunerationCfDentistPage] = useState<number>(1)
  const [remunerationCfDentistTypePage, setRemunerationCfDentistTypePage] = useState<number>(1)
  const [remunerationCfDentistLimitPage, setRemunerationCfDentistLimitPage] = useState<number>(10)
  const [checkDF, setCheckDF] = useState<boolean>(false)

  const [popFormula, setPopFormula] = useState<boolean>(false)
  const [imageFormula, setImageFormula] = useState<string>('')

  const branchInfo = getClinicInfo()


  const [snType, setSnType] = useState(false)

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  const loadPermissExport = useCallback(async () => {
    const branchId = getBranch()
    AboutUs.detailClinic(Number(branchId))
      .then(({ data }) => {
        dispatch(editBranchInfo({ value: { ...data } }))
        setSecureItem(KEY_STORAGE.CLINIC_INFO, JSON.stringify({ ...data, lastUpdate: moment().format('YYYY-MM-DD HH:mm') }))
      })
      .catch((e) => { return })
  }, [])

  useEffect(() => {
    loadPermissExport()
  }, [])

  useEffect(() => {
    setSecureItem(KEY_STORAGE.REPORT_CONDITION, (branchInfo?.defaultDfReport || '1').toString())
    setSelectedOptionPrice(branchInfo?.defaultDfReport || '1')
    setOptionDf(branchInfo?.defaultDfCon || '3')
  }, [branchInfo])

  const verifyPermission = async () => {
    const condition: FindAllReportInterface = {
      page: 1,
      pageLimit: 200
    }
    setOptionDf(branchInfo.defaultDfCon)
    ReportApi.reportList(condition).then(({ data }) => {
      const check = _.find(data, (val: any) => String(val.reportKey) === 'REMUNERATION_CLINIC_FEE_ALL_DENTIST') ? true : false
      if (!check) {
        history.push(routeName.report)
        return false
      }
    })

    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })

    ClinicApi.allBillPrefix()
      .then((resp) => setReceiptPrefix(resp.data))
      .catch((e) => {
        return
      })

    // โหลดรายชื่อหมอ ย้ายไป useEffect เดียวด้านล่าง (loader เดียว — กรองตามสาขา + ช่วงวันที่)

    LabGroupsApi.findAll({ page: 1, pageLimit: 100, status: 'ACTIVE' })
      .then(({ data: dataLabGroup }) => {
        setLabGroup(dataLabGroup)
      })
      .catch((e) => {
        return
      })

    LabCompanyApi.findAll({ page: 1, pageLimit: 100, status: 'ACTIVE' })
      .then(({ data: dataLabCompany }) => {
        setLabCompany(dataLabCompany)
      })
      .catch((e) => {
        return
      })

    // DoctorScheduleApi.findAllDoctor({ branchId: branchId }).then(({ data: dataAllDoctor }) => {
    //   const dentists: DentistInterface[] = dataAllDoctor.map((d: any) => {
    //     return {
    //       dentistId: d.userId,
    //       dentistFullname: d.fullname
    //     }
    //   })
    //   // setDoctorsMultiple(dentists)
    //   setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
    // })
    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])

  // โหลดรายชื่อหมอ — loader เดียว กรองตามสาขา (branchId) + ช่วงวันที่ที่เลือก
  // ใส่ option "ไม่ระบุแพทย์" (999999) ในรายการเสมอ เพื่อให้ติ๊กเลือก + แสดงชื่อได้
  useEffect(() => {
    if (rangeDate[1] === 'Invalid date' || !rangeDate[1]) return
    ClinicApi.findAllDoctors('', '', rangeDate[0], rangeDate[1], branchId)
      .then((resp) => {
        const dentists: DentistInterface[] = resp.data.map((d: any) => ({
          dentistId: d.userId,
          dentistFullname: d.fullname
        }))
        setDoctors([{ userId: 999999, firstname: '', lastname: '', fullname: t('REPORT.TITLE.NO_DOCTOR') }, ...resp.data])
        setDoctorsMultiple(dentists)
        setSelectDoctors(['ALL', ...dentists.map((d: DentistInterface) => d.dentistId)])
      })
      .catch((e) => {
        return
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchId, rangeDate[0], rangeDate[1]])

  const fetchRemunerationClinicFee = useCallback(() => {
    setLoading(true)
    let condition: FindAllReportInterface = {
      page: remunerationCfDentistPage,
      pageLimit: remunerationCfDentistLimitPage,
      branchId: branchId,
      dateStart: rangeDate[0],
      dateEnd: rangeDate[1],
      labCompanyId: labCompanyId,
      labGroupId: labGroupId,
      optionPrice: selectedOptionPrice

    }

    if (selectDoctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (prefix) condition = { ...condition, prefix: prefix === 'ALL' ? '' : prefix }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (optionDf) condition = { ...condition, optionDf: Number(optionDf) }
    if (rangeDate) {
      if ((rangeDate[0] !== null || rangeDate[0] !== '') && (rangeDate[1] !== null || rangeDate[1] !== '')) condition = { ...condition, dateStart: rangeDate[0], dateEnd: rangeDate[1] }
    }

    ReportApi.reportRemittanceClinicFeeAllDentist(condition)
      .then(({ headers, data }) => {
        getRemunerationCfDentistData(data)
        setRowCount(headers['x-total'])
      })
      .catch((e) => setLoading(false))
      .finally(() => setLoading(false))
  }, [sortBy, sortType, branchId, labCompanyId, labGroupId, remunerationCfDentistTypePage, remunerationCfDentistPage, remunerationCfDentistLimitPage, rangeDate, selectDoctors, prefix, doctors, optionDf, selectedOptionPrice])

  const setDoc = (data: any) => {
    const sortedSelectData = data.sort((a: any, b: any) => {
      const idA = a.dentistId
      const idB = b.dentistId
      return selectDoctors.indexOf(idA) - selectDoctors.indexOf(idB)
    })
    return sortedSelectData
  }
  const filter = [
    branchId === 0 ? `${t(`REPORT.FILTER.ALL`)}` : `${_.get(_.find(branches, { branchId: branchId }), 'branchName') || _.get(_.find(branches, { branchId: branchId }), 'branchNameEn')}`,
    rangeDate[0],
    rangeDate[1],
    prefix === 'ALL' ? `${t(`REPORT.FILTER.ALL`)}` : prefix,
    _.isEmpty(selectDoctors) || _.includes(selectDoctors, '')
      ? ` ${t('REPORT.FILTER.NO_SELECT')}`
      : _.includes(selectDoctors, 'ALL')
        ? `${t('REPORT.FILTER.ALL')}`
        : `${setDoc(doctorsMultiple.filter((d: any) => selectDoctors.includes(d.dentistId)))
          ?.map((d: any) => d.dentistFullname)
          .slice(0, 3) // เเสดงเเค่ 3 คนเเรก
          .join(', ')}`,
    labGroupId ? `${_.get(_.find(labGroup, { labGroupId: labGroupId }), 'labGroupName') || _.get(_.find(labGroup, { labGroupId: labGroupId }), 'labGroupNameEn')} ` : `${t(`REPORT.FILTER.ALL`)}`,
    labCompanyId ? `${_.get(_.find(labCompany, { labCompanyId: labCompanyId }), 'labCompanyName') || _.get(_.find(labCompany, { labCompanyId: labCompanyId }), 'labCompanyNameEn')} ` : `${t(`REPORT.FILTER.ALL`)}`,
    optionDf === '0' ? t('REPORT.FILTER.NO_CAL_DF') : t(`REPORT.FILTER.DF${optionDf}`)
  ]
  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST`)} (${rangeDate[0]} - ${rangeDate[1]})`,
    sheetName: `${t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST`)}`
  })

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangeRowsPerPage = (limit: number) => setRemunerationCfDentistLimitPage(limit)

  const handleChangePage = (val: number) => setRemunerationCfDentistPage(val)

  useEffect(() => {
    fetchRemunerationClinicFee()
  }, [sortBy, sortType])

  useEffect(() => {
    if (imageFormula === '') {
      setPopFormula(false)
    } else {
      setPopFormula(true)
    }
  }, [imageFormula])


  const handleExport = async () => {
    setLoading(true)
    try {
      const report: any = {
        branchName: filter[0],
        dateStart: filter[1],
        dateEnd: filter[2],
        receiptPrefix: filter[3],
        doctorsFilter: filter[4],
        labGroupName: filter[5],
        labCompanyName: filter[6],
        // optionDfLabel: filter[7],
        includeSn: snType,
        data: remunerationCfDentistData,
        doctors: doctorsMultiple,
        t: t
      }
      await ExportClinicFeeDentist(report)
    } catch (error) {
      console.error('Error exporting to Excel:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box>
      <HeaderCard text={t(`REPORT.REPORT_NAME.REMUNERATION_CLINIC_FEE_ALL_DENTIST`)} />
      <Box padding="16px">
        <Grid container spacing="8px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('REPORT.FILTER.BRANCH')}
              value={branchId}
              onChange={e => {
                setBranchId(e.target.value)
                setRemunerationCfDentistPage(1)
              }}
              options={branches.map(b => ({
                value: b.branchId,
                name: b.branchName || b.branchNameEn || ''
              }))}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <InputSecondNewRangePicker
              inputHeight={40}
              value={rangeDate || emptyRangePicker}
              onchange={(val: any) => {
                setRangeDate([moment(val[0]).format('YYYY-MM-DD'), moment(val[1]).format('YYYY-MM-DD')])
                // setRemunerationCfDentistPage(1)
                // setRemunerationCfDentistTypePage(1)
              }}
              label={''}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(e) => {
                setPrefix(e.target.value)
                setRemunerationCfDentistPage(1)
                setRemunerationCfDentistTypePage(1)
              }}
              value={prefix}
              options={[{ value: 'ALL', name: t('REPORT.FILTER.ALL') },
              ...receiptPrefix.map(b => ({
                value: b.prefix,
                name: b.prefix
              }))
              ]}
              label={t('REPORT.FILTER.RECEIPT_TYPE')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectCheckBoxInput
              label={t('USER_DOCTOR')}
              options={doctors.map((d: any) => ({
                id: d.userId,
                name: d.fullname
              }))}
              selected={selectDoctors}
              onChange={(ids: any) => {
                setSelectDoctors(ids)
                setOpenFilterDoctors(false)
              }}
              fullWidth
              width="100%"
              searchable
              searchPlaceholder={t('REPORT.FILTER.DOCTOR_SEARCH_PLACEHOLDER')}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <AutocompleteSelect
              key={'lab-group'}
              labelId="lab-group"
              inputLabel={t('REPORT.FILTER.LAB_GROUP')}
              noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
              options={labGroup}
              getOptionLabel={(option: any) => option.labGroupName}
              renderOption={(props, option: any) => (
                <Box key={option} component="li" {...props}>
                  {option.labGroupName}
                </Box>
              )}
              onchange={(e, value: any) => {
                if (value) {
                  setLabGroupId(value.labGroupId)
                }
              }}
              value={_.find(labGroup, (val: any) => Number(val.labGroupId) === Number(labGroupId)) || null}
              disableClearable
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <AutocompleteSelect
              key={'lab-company'}
              labelId="lab-company"
              inputLabel={t('REPORT.FILTER.LAB_COMPANY')}
              noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
              options={labCompany}
              getOptionLabel={(option: any) => option.labCompanyName}
              renderOption={(props, option: any) => (
                <Box key={option} component="li" {...props}>
                  {option.labCompanyName}
                </Box>
              )}
              onchange={(e, value: any) => {
                if (value) {
                  setLabCompanyId(value.labCompanyId)
                }
              }}
              value={_.find(labCompany, (val: any) => Number(val.labCompanyId) === Number(labCompanyId)) || null}
              disableClearable
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} xl={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <MainButton onClick={() => fetchRemunerationClinicFee()} title={t('INPUT.SEARCH')} type='primary' variant='contained' style={{ width: '120px' }}></MainButton>
              <UseStyled.DropdownDocument title={t('REGISTER.BUTTON.PRINT_DOCUMENT')} id="dropdown-basic" className="ml-xl-auto">
                <UseStyled.DropdownItem onClick={handleExport}>{t('Excel')}</UseStyled.DropdownItem>
                <FucntionPrint
                  content={() => componentRef.current}
                  removeIfram
                  trigger={() => <UseStyled.DropdownItem>{t('PDF')}</UseStyled.DropdownItem>}
                  style={`@page { size: 1122.519685px 793.7007874px ;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                />
              </UseStyled.DropdownDocument>
            </Box>
          </Grid>
        </Grid>
        <Box className={'mt-3 pl-xl-3 pr-xl-2 pb-4'}>
          <RemunerationClinicFeeDentistList
            page={remunerationCfDentistPage}
            pageLimit={remunerationCfDentistLimitPage}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={remunerationCfDentistData}
            doctors={doctorsMultiple}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            filter={filter}
            filterDateStart={rangeDate[0]}
            filterDateEnd={rangeDate[1]}
            componentRef={componentRef}
          />
        </Box>
      </Box>

      <Loading show={loading} type="fullLoading" />
      {popFormula && imageFormula !== '' && <ReportFormulaDF img={imageFormula} setImg={setImageFormula} />}
    </Box>
  )
}
